import React, { FC, useRef } from 'react';
import { VisitorView } from 'src/editor/insights/constants';
import { DashboardInsightsJourneysJourneyVisitorsTable } from 'src/dashboard/insights/home/visitors-table';
import { TimePeriodParam } from 'src/dashboard/insights/constants';
import { DashboardInsightsJourneysTabType } from 'src/dashboard/insights/journeys/constants';

type DashboardInsightsJourneysJourneyContentProps = {
  activeTabType: DashboardInsightsJourneysTabType;
  insights: any;
  timePeriodParam?: TimePeriodParam;
};

export const DashboardInsightsJourneysJourneyContent: FC<DashboardInsightsJourneysJourneyContentProps> = ({
  activeTabType,
  timePeriodParam,
  insights,
}) => {
  const allVisitorsFetcherRef = useRef<() => Promise<{ views: VisitorView[] }>>();

  return (
    <>
      <div className='grow flex flex-col mt-3'>
        <DashboardInsightsJourneysJourneyVisitorsTable
          timePeriodParam={timePeriodParam}
          insights={insights}
          setAllVisitorsFetcher={(fetcher) => {
            allVisitorsFetcherRef.current = fetcher;
          }}
        />
      </div>
    </>
  );
};
